export const ProspectLeadsTableHeader = (isDeptOgdOrCsd=false,isActionDisabled=false) => [
  { field: 'sl_no', headerName: 'Sl No', width: 100},
  { field: 'name', headerName: 'Name', width: 220, toolTipGetter: true },
  { field: 'email', headerName: 'Email', width: 220, toolTipGetter: true },
  {
    field: 'phone',
    headerName: 'Contact',
    width: 180,
    renderCell: (params) => `+${params.row.country_code || '91'} ${params.row.phone || ''}`,
    toolTipGetter: true,
  },
  { field: 'currentDepartmentName', headerName: 'Current Department', width: 270, toolTipGetter: true },
  { field: 'currentEmployeeName', headerName: 'Current Employee', width: 200, toolTipGetter: true },
  { field: 'createdByName', headerName: 'Created By ', width: 200, toolTipGetter: true },
  { field: 'updatedByName', headerName: 'Updated By ', width: 200, toolTipGetter: true },

  { field: 'currentStatusName', headerName: 'Status', width: 200, toolTipGetter: true },
...(
  isDeptOgdOrCsd && !isActionDisabled ? [
 {
    field: 'edit',
    headerName: 'Edit Lead',
    type: 'action',
    actionType: 'edit',
    actionKey: 'editLead',
    width: 170,
    buttonName: 'Edit',
  },
  {
    field: 'assign',
    headerName: 'Assign To',
    type: 'action',
    actionType: 'view',
    actionKey: 'assignLead',
    width: 180,
    buttonName: 'Assign',
  },
  {
    field: 'transfer',
    headerName: 'Transfer To Department',
    type: 'action',
    actionType: 'view',
    actionKey: 'transferLead',
    width: 230,
    buttonName: 'Transfer',
  },
  {
    field: 'status',
    headerName: 'Update Status',
    type: 'action',
    actionType: 'view',
    actionKey: 'statusLead',
    width: 200,
    buttonName: 'Status',
  },
  ]:[]
),
 
  // {
  //   field: 'delete',
  //   headerName: 'Delete',
  //   type: 'action',
  //   actionType: 'delete',
  //   actionKey: 'deleteLead',
  //   width: 200,
  //   buttonName: 'Delete',
  // },
  {
    field: 'view',
    headerName: 'View History',
    type: 'action',
    actionType: 'view',
    actionKey: 'viewLead',
    width: 200,
    buttonName: 'View',
  },
];
